import { Languages } from "lucide-react";
import { useLang } from "@/lib/i18n";

export const LanguageToggle = ({ testId = "lang-toggle-btn", className = "" }) => {
  const { lang, toggle } = useLang();
  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={lang === "es" ? "Switch to English" : "Ver en español"}
      className={`inline-flex items-center gap-1.5 border border-slate-300 hover:border-emerald-600 hover:text-emerald-700 text-slate-700 rounded-full px-3 py-1.5 text-xs font-bold tracking-wider transition-colors duration-200 ${className}`}
      data-testid={testId}
    >
      <Languages className="w-3.5 h-3.5" />
      <span className={lang === "en" ? "text-emerald-600" : "text-slate-400"}>EN</span>
      <span className="text-slate-300">|</span>
      <span className={lang === "es" ? "text-emerald-600" : "text-slate-400"}>ES</span>
    </button>
  );
};
